var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 26.6653C26.667 19.3016 32.6365 13.332 40.0003 13.332H100L133.334 46.6654V133.332C133.334 140.696 127.364 146.665 120 146.665H40.0003C32.6365 146.665 26.667 140.696 26.667 133.332V26.6653Z",
    fill: "#1E95F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 13.332L133.333 46.6654H100V13.332Z",
    fill: "#A5D5FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.334 73.332H46.667V79.9987H113.334V73.332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.667 86.6654H46.667V93.332H106.667V86.6654Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.667 99.9987H113.334V106.665H46.667V99.9987Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3337 113.332H46.667V119.999H93.3337V113.332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImage);
export default __webpack_public_path__ + "static/media/document-image.f6054c82e7988c43b051355251048146.svg";
export { ForwardRef as ReactComponent };